export const SERVICES = [
  {
    id: 'web',
    title: 'Desenvolvimento Web',
    description: 'Sites, sistemas web e aplicações responsivas com as tecnologias mais modernas do mercado. Frontend e Backend de alta performance.',
    icon: 'Code',
    tags: ['React', 'Vue.js', 'Node.js', 'PHP'],
  },
  {
    id: 'mobile',
    title: 'Desenvolvimento Mobile',
    description: 'Aplicativos nativos e híbridos para iOS e Android. Experiências mobile que encantam seus usuários e geram resultados.',
    icon: 'PhoneIphone',
    tags: ['React Native', 'Flutter', 'iOS', 'Android'],
  },
  {
    id: 'hosting',
    title: 'Hospedagem Dedicada',
    description: 'Servidores dedicados de alta performance com uptime garantido. Infraestrutura robusta para suas aplicações críticas.',
    icon: 'Dns',
    tags: ['VPS', 'Dedicado', 'SSL', 'Backup'],
  },
  {
    id: 'cloud',
    title: 'Cloud Computing',
    description: 'Soluções em nuvem escaláveis e seguras. Migração, gerenciamento e otimização de recursos em AWS, Azure e Google Cloud.',
    icon: 'Cloud',
    tags: ['AWS', 'Azure', 'GCP', 'Docker'],
  },
  {
    id: 'support',
    title: 'Suporte Especializado',
    description: 'Equipe técnica dedicada para suporte e manutenção. Atendimento ágil e resolução eficiente de problemas técnicos.',
    icon: 'SupportAgent',
    tags: ['24/7', 'SLA', 'Help Desk', 'Remoto'],
  },
  {
    id: 'monitoring',
    title: 'Monitoramento 365',
    description: 'Monitoramento contínuo de infraestrutura e aplicações. Alertas em tempo real e dashboards personalizados.',
    icon: 'Visibility',
    tags: ['Uptime', 'Alertas', 'Métricas', 'Logs'],
  },
  {
    id: 'devops',
    title: 'Automação DevOps',
    description: 'CI/CD, infraestrutura como código e automação de processos. Acelere suas entregas com práticas DevOps modernas.',
    icon: 'Settings',
    tags: ['CI/CD', 'Kubernetes', 'Terraform', 'Jenkins'],
  },
  {
    id: 'ai',
    title: 'Chatbot & IA',
    description: 'Chatbots inteligentes e soluções com Inteligência Artificial. Automatize atendimento e processos com tecnologia de ponta.',
    icon: 'SmartToy',
    tags: ['ChatGPT', 'NLP', 'Machine Learning', 'Automação'],
  },
];

export const PRODUCTS = [
  {
    id: 'helvia',
    name: 'Helvia',
    category: 'Suporte',
    description: 'Sistema completo de Help Desk e Suporte ao Cliente. Gerencie tickets, SLAs e atendimentos de forma eficiente.',
    url: 'https://helvia.com.br',
    status: 'active',
  },
  {
    id: 'upguard',
    name: 'Upguard',
    category: 'Monitoramento',
    description: 'Monitoramento Web em tempo real. Acompanhe uptime, performance e receba alertas instantâneos sobre sua infraestrutura.',
    url: 'https://upguard.com.br',
    status: 'active',
  },
  {
    id: 'schoola',
    name: 'Schoola',
    category: 'Educação',
    description: 'Sistema de Gestão Educacional completo. Controle acadêmico, financeiro e administrativo para instituições de ensino.',
    url: 'https://schoola.com.br',
    status: 'active',
  },
  {
    id: 'clarafin',
    name: 'Clarafin',
    category: 'Finanças',
    description: 'Gestão Financeira Pessoal e Empresarial. Controle suas finanças, fluxo de caixa e tenha relatórios detalhados.',
    url: 'https://clarafin.com.br',
    status: 'active',
  },
  {
    id: 'lms',
    name: 'LMS',
    category: 'E-learning',
    description: 'Ambiente de Aprendizagem Virtual completo. Crie cursos, trilhas de conhecimento e acompanhe o progresso dos alunos.',
    status: 'coming_soon',
  },
  {
    id: 'erp',
    name: 'ERP',
    category: 'Gestão',
    description: 'Sistema integrado para pequenas e médias empresas. Vendas, estoque, compras, financeiro e muito mais em um só lugar.',
    status: 'coming_soon',
  },
  {
    id: 'boards',
    name: 'Boards',
    category: 'Projetos',
    description: 'Gestão de Projetos centralizada e simplificada. Organize tarefas, equipes e prazos com uma interface intuitiva e poderosa.',
    featured: false,
    status: 'coming_soon',
  },
  {
    id: 'imovik',
    name: 'Imovik',
    category: 'Imobiliário',
    description: 'Gestão completa para imobiliárias. Gerencie propriedades, divulgue imóveis em construção e acompanhe vendas e locações.',
    status: 'coming_soon',
  },
];

export const STATS = [
  { value: '5+', label: 'Anos de experiência' },
  { value: '50+', label: 'Projetos entregues' },
  { value: '8', label: 'Produtos próprios' },
];

export const NAV_ITEMS = [
  { label: 'Início', href: '/', isRoute: true },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Sobre', href: '/sobre', isRoute: true },
  { label: 'Produtos', href: '#produtos' },
  { label: 'Contato', href: '#contato' },
];

export const SERVICE_OPTIONS = [
  { value: '', label: 'Selecione um serviço' },
  { value: 'desenvolvimento-web', label: 'Desenvolvimento Web' },
  { value: 'desenvolvimento-mobile', label: 'Desenvolvimento Mobile' },
  { value: 'hospedagem', label: 'Hospedagem Dedicada' },
  { value: 'cloud', label: 'Cloud Computing' },
  { value: 'suporte', label: 'Suporte Especializado' },
  { value: 'monitoramento', label: 'Monitoramento 365' },
  { value: 'devops', label: 'Automação DevOps' },
  { value: 'chatbot-ia', label: 'Chatbot & IA' },
  { value: 'produtos', label: 'Produtos ShiftLabs' },
  { value: 'outro', label: 'Outro' },
];
